import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import iconInfo from 'assets/images/icon_info.svg';
import { useShadowRoot } from './../../context/ShadowRootContext';

const InfoTooltip = (props) => {

    const shadowRoot = useShadowRoot();

    return (
        <OverlayTrigger container={shadowRoot} placement="right" overlay={
            <Tooltip>{props.label}</Tooltip>
        }>
        <img src={iconInfo} alt="info" className="InfoTooltip" />
        </OverlayTrigger>
    );
}

export default InfoTooltip;